<template>
    <div class="admin-notes-trans">
        <fieldset class="padding-sm-top">
            <legend>
                Transition Notes
            </legend>

            <modal :name=noteable_id
                   :adaptive="true"
                   :scrollable="true"
                   height="auto">
                <div class="dashboard-block" :class="{loading: loading}">
                    <form @submit.prevent="submitNote" method="POST"
                          accept-charset="UTF-8"
                          class="margin-md-top"
                          enctype="multipart/form-data" novalidate="novalidate">

                        <header>
                            <div class="row">
                                <div class="col-xs-6">
                                    <h4>Create Note</h4>
                                </div>
                                <div class="col-xs-6 text-right">
                                    <label class="pointer">
                                        Public Note
                                        <input autocomplete="off" required
                                               v-model="note.publicNote"
                                               name="Note[scope]"
                                               type="checkbox" aria-required="true">
                                    </label>
                                </div>
                            </div>
                        </header>

                        <div class="form-group has-feedback" :class="{'has-error': errors.has('Note[message]')}">
                            <label for="note-message">
                                Message
                                <span class="label label-warning" v-if="note.publicNote">Resident Notification</span>
                                <span class="label label-primary" v-else>Private</span>
                            </label>

                            <textarea v-validate="'required'"
                                      v-model.string="note.message"
                                      class="form-control"
                                      id="note-message"
                                      placeholder="New Note"
                                      cols="50"
                                      rows="3"
                                      aria-required="true"
                                      required
                                      name="Note[message]">
                            </textarea>

                            <span v-show="errors.has('Note[message]')" class="help-block">
                                {{ errors.first('Note[message]') }}
                            </span>
                        </div>

                        <div class="markdown-hints text-right">
                            <h3>###heading</h3><strong>**bold**</strong><i>_italics_</i><code>`code`</code>
                            <blockquote>>quote</blockquote>
                        </div>

                        <div class="form-group has-feedback">
                            <input class="form-control dropable" id="note-file" name="Note[file]" type="file"
                                   @change="onFileChange">
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-sm-6 col-ld-4 form-group pull-right">
                                <button type="submit" class="btn btn-block"
                                        :class="{ 'btn-warning': note.publicNote, 'btn-success': !note.publicNote }"
                                        :disabled="loading">
                                    Save Note
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </modal>

            <div class="notes-wrapper">
                <div v-for="(note, index) in displayNotes" class="note">
                    <h5 class="day"
                        v-if="index === 0 || notes[index - 1].created_at.clone().startOf('day').day() !== note.created_at.clone().startOf('day').day()">
                        {{ note.created_at.local().format('ddd, MMMM Do, YYYY') }}
                    </h5>

                    <h5 class="user">
                        <span class="user-name">
                            {{note.user.first_name}} {{note.user.last_name}}
                        </span>
                        <span class="created-at">
                            {{ note.created_at.local().format('h:mm a') }}
                        </span>
                        <span class="label label-warning" v-if="note.scope == '1'">Resident Notification</span>
                        <span class="label label-primary" v-if="note.scope == '0'">Private</span>
                        <a v-if="note.noteableUrl !== null" :href="note.noteableUrl">
                            <span v-html="note.noteableLabel"></span>
                        </a>
                        <span v-else v-html="note.noteableLabel"></span>


                        <a href="javascript://void(0)" v-if="user_id === note.user_id && editNote === null"
                           @click="setEditNote(note)"
                           class="remove-btn">
                            Edit
                        </a>

                        <a href="javascript://void(0)" v-if="editNote !== null && editNote.id === note.id"
                           @click="setEditNote(null)"
                           class="remove-btn">
                            Cancel
                        </a>
                    </h5>

                    <div v-if="editNote === null || editNote.id !== note.id" class="message"
                         v-html="note.displayMessage">
                    </div>

                    <form v-else @submit.prevent="submit" method="POST" accept-charset="UTF-8"
                          enctype="multipart/form-data" novalidate="novalidate" class="margin-lg-top">

                        <div class="form-group text-right">
                            <label class="pointer">
                                Public Note
                                <input autocomplete="off" required
                                       v-model.number="editNote.scope"
                                       true-value="1"
                                       false-value="0"
                                       name="Note[scope]"
                                       type="checkbox" aria-required="true">
                            </label>
                        </div>

                        <div class="has-feedback margin-sm-top form-group">
                            <textarea class="form-control" autocomplete="off" required
                                      type="text" v-model.string="editNote.message" aria-required="true">
                            </textarea>
                        </div>

                        <div class="row">
                            <div class="col-xs-5 form-group">
                                <button type="button" class="btn btn-sm btn-warning" @click="removeNote"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="col-xs-7 form-group text-right">
                                <button type="button" class="btn btn-sm btn-success btn-block" @click="saveNote"
                                        :disabled="loading">
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>

                    <ul v-if="note.files" class="list-unstyled">
                        <li v-for="file in note.files">
                            <a :href="'/files/' + file.id + '/download'"
                               class="truncate margin-sm-left display-block"
                               target="_blank">
                                <i class="fa fa-file-o" aria-hidden="true"></i>&nbsp;{{file.name}}
                            </a>
                        </li>
                    </ul>
                </div>

                <a href="javascript://void(0)" @click="toggleShowAll"
                   v-if="notes.length > displayNotesCount && !showAll">
                    Show All Notes
                </a>
            </div>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: {
            noteable_id: {
                required: true,
                type: String
            },

            noteable_type: {
                required: true,
                type: String
            },

            user_id: {
                required: true,
                type: String
            },
        },

        data(){
            return {
                loading: true,
                note: {
                    publicNote: false,
                    message: '',
                    file: null
                },
                showAll: false,
                notes: [],
                editNote: null,
                file: null,
                displayNotesCount: 5
            };
        },

        mounted(){
            this.loadNotes()
                .catch( this.$root.handleErrors )
                .finally( () => {
                    this.loading = false;
                } );
        },

        computed: {
            displayNotes(){
                if( !this.showAll && this.notes.length > this.displayNotesCount ){
                    return _.slice( this.notes, 0, this.displayNotesCount );
                }
                else{
                    return this.notes;
                }
            }
        },

        methods: {
            loadNotes(){
                var url = '/api/notes?noteable_id=' + this.noteable_id +
                    '&noteable_type=' + this.noteable_type +
                    '&sort_by=created_at&sort_dir=DESC';

                return axios.get( url )
                    .then( ( response ) => {
                        this.notes = response.data.Notes.map( ( note ) => {
                            note.created_at = new moment.utc( note.created_at );

                            return note;
                        } );
                    } )
                    .catch( this.$root.handleErrors );
            },

            setEditNote( note ){
                this.loading = true;
                if( note === null ){
                    this.loadNotes();
                }

                this.loading = false;
                this.editNote = note;
            },

            saveNote(){
                this.loading = true;

                axios.put( '/api/notes/' + this.editNote.id, {
                    Note: {
                        message: this.editNote.message,
                        scope: this.editNote.scope
                    }
                } )
                    .then( () => {
                        this.editNote = null;

                        return this.loadNotes();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            removeNote(){
                this.loading = true;

                axios.delete( '/api/notes/' + this.editNote.id )
                    .then( () => {
                        this.editNote = null;

                        return this.loadNotes();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            toggleShowAll(){
                this.showAll = !this.showAll;
            },

            submitNote(){
                this.$validator.validateAll().then( ( valid ) => {
                    if( valid ){

                        var data = new FormData();
                        data.append( 'Note[message]', this.note.message );
                        data.append( 'Note[noteable_id]', this.noteable_id );
                        data.append( 'Note[noteable_type]', this.noteable_type );
                        data.append( 'Note[scope]', this.note.publicNote ? 1 : 0 );

                        if( this.note.file ){
                            data.append( 'Note[file]', this.note.file );
                        }

                        this.loading = true;

                        return axios.post( '/api/notes', data, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        } )
                            .then( () => {
                                Object.assign( this.$data.note, this.$options.data().note );

                                this.$modal.hide( this.noteable_id );

                                return this.loadNotes();
                            } )
                            .finally( () => {
                                this.loading = false;
                            } )
                            .catch( this.$root.handleErrors );
                    }
                } );
            },

            onFileChange( e ){
                this.note.file = e.target.files[ 0 ];
            },
        }
    }
</script>